import React, { Component } from "react";
import { 
  Modal, 
  ModalHeader, 
  ModalBody 
} from "reactstrap";
import MoveStudentsToClassForm from "../../components/Forms/MoveStudentsToClassForm";
import { FormattedMessage } from 'react-intl';

class MoveExistingStudentToClassModal extends Component {
 
  render() {
    return (
      <Modal size="lg" isOpen={this.props.isOpen} toggle={this.props.toggle}>
        <ModalHeader><FormattedMessage id="MoveExistingStudentsToClass" /></ModalHeader>
        <ModalBody>
          <MoveStudentsToClassForm
            loadstudents={this.props.loadstudents}
            classId={this.props.classId}
            dismissModal={this.props.toggle}
            students={this.props.students}
            existingStudents={this.props.existingStudents}
          />
        </ModalBody>
      </Modal>
    );
  }
}

export default MoveExistingStudentToClassModal;
